import { render } from "./HeroiconsOutlineTrash.vue?vue&type=template&id=6469b340"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTrash.vue"]])

export default __exports__